export type DocumentStatusKey = 0 | 1 | 2 | 3;

export type DocumentStatusValue = 'Draft' | 'Published' | 'Archived' | 'Deleted';

export type DocumentStatusMap = {
    [key in DocumentStatusKey]: DocumentStatusValue;
};

export const DOCUMENT_STATUS_MAP: Readonly<Record<DocumentStatusKey, DocumentStatusValue>> = {
    0: 'Draft',
    1: 'Published',
    2: 'Archived',
    3: 'Deleted'
};